/**
 * Re-exported so `declare module` augmentation of the RemoteConfigMap merges
 * across consumers; removing the root re-export breaks the merge and typecheck.
 * @public
 */
export type { RemoteConfigMap } from './hooks'
/** @public — permission check/mode/result types; public API without in-repo consumers. */
export type {
  PermissionCheck,
  PermissionMode,
  SelfPermissionsResult,
  UseHasPermissions,
} from './permissions'
export type { AppConfigContextValue } from './types'

export { AppConfigContext } from './context'
export { useFeatureFlag, useRemoteConfig } from './hooks'
export { MockAppConfigProvider } from './mock-app-config-provider'
/** @public — permission helpers + enums; public API without in-repo consumers. */
export {
  CheckOnlyPermission,
  createUseHasPermissions,
  hasPermission,
  Permission,
  TradingPermissions,
} from './permissions'
export {
  PermissionsProvider,
  useHasPermissions,
} from './permissions-context'
